import { useCallback, useEffect, useState } from 'react'
import { CellProps } from 'react-table'
import AddSuperAdminUserPopup from '../../components/AddSuperAdminUserPopup'
import BaseTable from '../../components/BaseTable/BaseTable'
import DashboardWrapper from '../../components/MainDashboardWrapper/DashboardWrapper'
import { getAllReportViewers, getAllSuperAdmins, removeUserFromSuperAdmin, setUserReportViewer } from './helper'
import { Button } from '@mantine/core'

type Props = {}

export default function UsersPage({}: Props) {
  const [users, setUsers] = useState([])
  const [reportViewers, setReportViewers] = useState([])

  const loadPage = useCallback(() => {
    getAllSuperAdmins().then((res) => {
      setUsers(res.data)
    })
    getAllReportViewers().then((res) => {
      setReportViewers(res.data)
    })
  }, [])

  useEffect(() => {
    loadPage()
  }, [loadPage])

  const columns: any[] = [
    {
      Header: 'Name',
      accessor: 'attributes.profile.displayName',
    },
    {
      Header: 'Email',
      accessor: 'attributes.email',
    },
    {
      Header: 'Action',
      accessor: 'id.uuid',
      Cell: (cellProps: CellProps<any>) => {
        return (
          <div>
            <Button
              color="red"
              // size="small"
              onClick={() => {
                if (window.confirm('Are you sure?')) {
                  removeUserFromSuperAdmin(cellProps.value)
                    .then(() => {
                      loadPage()
                      alert('Success')
                    })
                    .catch((err) => {
                      // console.log(
                      //   '🚀 ~ file: AddCompanyCoachPopup.tsx:49 ~ AddCompanyCoachPopup ~ err:',
                      //   { err }
                      // )
                      alert(err.response.data)
                    })
                }
              }}
            >
              Remove user from super admin
            </Button>
          </div>
        )
      },
    },
  ]

  const reportViewerColumns: any[] = [
    ...columns.slice(0, 2),
    {
      Header: 'Action',
      accessor: 'id.uuid',
      Cell: (cellProps: CellProps<any>) => (
        <Button
          color="red"
          onClick={() => {
            if (window.confirm('Remove reports access for this user?')) {
              setUserReportViewer(cellProps.value, false)
                .then(() => loadPage())
                .catch((err) => alert(err.response?.data?.message || 'Failed'))
            }
          }}
        >
          Remove reports access
        </Button>
      ),
    },
  ]

  return (
    <DashboardWrapper page="user" title="Admin Users">
      <AddSuperAdminUserPopup
        cb={() => {
          loadPage()
        }}
        trigger={
          <Button className="self-end" type="submit">
            Add super admin user
          </Button>
        }
      />
      <BaseTable data={users} columns={columns} />

      <div className="flex items-end justify-between mt-10 mb-2">
        <div>
          <p className="text-xl font-bold">Reports-only access</p>
          <p className="text-gray-500 text-sm">
            These users (e.g. marketing) can log in here but only see the Reports page, including CSV export.
          </p>
        </div>
        <AddSuperAdminUserPopup
          cb={() => loadPage()}
          actionLabel="Give reports access"
          onAction={(uuid) => setUserReportViewer(uuid, true)}
          trigger={<Button variant="outline">Give reports access</Button>}
        />
      </div>
      <BaseTable data={reportViewers} columns={reportViewerColumns} />
    </DashboardWrapper>
  )
}
